import { useLayoutEffect } from 'react'
import { setCommonTrackingParameters } from '../../../tracking/tracking'
import { useAiDataExtractionBannerExperimentTracking } from './UseAiDataExtractionBannerExperimentTracking'
import { useHeyImmoExperimentTracking } from './UseHeyImmoExperimentTracking'
import { useRecommendedPriceExperimentTracking } from './UseRecommendedPriceExperimentTracking'

type UseExperimentTrackingParams = {
  hasAiDataExtractionBanner: boolean
  hasHeyImmo: boolean
  isAiDataExtractionReentryEnabled: boolean
  recommendedPriceEnabled: boolean
}

export function useExperimentTracking({
  hasAiDataExtractionBanner,
  hasHeyImmo,
  isAiDataExtractionReentryEnabled,
  recommendedPriceEnabled,
}: UseExperimentTrackingParams) {
  const aiDataExtractionBannerTrackingParameters = useAiDataExtractionBannerExperimentTracking(
    hasAiDataExtractionBanner && !isAiDataExtractionReentryEnabled
  )
  const heyImmoTrackingParameters = useHeyImmoExperimentTracking(hasHeyImmo)
  const recommendedPriceTrackingParameters = useRecommendedPriceExperimentTracking(
    !hasAiDataExtractionBanner && recommendedPriceEnabled
  )
  const commonExperimentTrackingParameters =
    heyImmoTrackingParameters ?? aiDataExtractionBannerTrackingParameters ?? recommendedPriceTrackingParameters

  useLayoutEffect(() => {
    if (!commonExperimentTrackingParameters) {
      return
    }

    setCommonTrackingParameters(commonExperimentTrackingParameters)

    return () => {
      setCommonTrackingParameters()
    }
  }, [commonExperimentTrackingParameters])
}
